import React from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { observer } from 'mobx-react';
import dictionary from '../../../Mobx/Dictionary';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import DownloadIcon from '@mui/icons-material/Download';
import additionalInfo from '../../../Mobx/AdditionalInfo';

const ExportToExcel = observer(() => {
    const exportToExcel = async () => {
        // const data = dictionary.current.data[dictionary.current.dictionaryType];
        // Deep Copy the data to avoid mutating the original data
        console.log("ExportToExcel: Starting export...");

        const data = JSON.parse(JSON.stringify(dictionary.current.data[dictionary.current.dictionaryType]));

        if (!data) {
            alert('No data to export.');
            return;
        }

        const fieldsOrder = dictionary.current.fields;
        const dictionaryType = dictionary.current.dictionaryType;

        // Reorder the data according to fieldsOrder
        const orderedData = await Promise.all(data.map(async entry => {
            let existsInfo;
            try {
                await additionalInfo.getExistsInfo(entry?.additionalInfo, dictionaryType, entry._id);
                if (!additionalInfo.existsInfo) {
                    existsInfo = null;
                } else {
                    existsInfo = JSON.parse(JSON.stringify(additionalInfo.existsInfo));
                }
            } catch (error) {
                console.error("Error fetching existsInfo for entry:", entry._id, error);
                existsInfo = null;
            }
            delete entry.additionalInfoCount;
            const orderedEntry = {};
            fieldsOrder.forEach(field => {
                if (entry.hasOwnProperty(field)) {
                    // Handle the categories field
                    if (field === 'categories' && Array.isArray(entry[field])) {
                        // Convert the array of category objects to a string of category names, separated by commas.
                        orderedEntry[field] = entry[field].map(category => category.name).join(', ');
                    } else {
                        orderedEntry[field] = entry[field];
                    }
                } else if (existsInfo && existsInfo.hasOwnProperty(field)) {
                    if (Array.isArray(existsInfo[field]) && existsInfo[field].length > 0 && existsInfo[field][0].hasOwnProperty('text')) {
                        // Convert the array of sentence objects to a string of sentences, separated by spaces.
                        orderedEntry[field] = '"' + existsInfo[field].map(element => element.text).join('", "') + '"';
                        if (field === 'sentences') {
                            orderedEntry['sentence'] = existsInfo['sentences'][0].text;
                        } else if (field === 'definitions') {
                            orderedEntry['definition'] = existsInfo['definitions'][0].text;
                        }
                    } else {
                        orderedEntry[field] = existsInfo[field];
                    }
                } else {
                    orderedEntry[field] = ''; // Ensuring every field exists, even if it's empty
                }
            });
            if(existsInfo) additionalInfo.clearExistsInfo();
            return orderedEntry;
        }));

        const CHUNK_SIZE = 50000;

        for (let i = 0; i < orderedData.length; i += CHUNK_SIZE) {
            const chunk = orderedData.slice(i, i + CHUNK_SIZE);

            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(chunk, { header: fieldsOrder });
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(blob, `${dictionaryType}_part_${i / CHUNK_SIZE + 1}.xlsx`);
        }
        console.log("ExportToExcel: Export completed.");
    };

    const getDictionaryName = (type) => {
        switch (type) {
            case 'dictionary_eng_to_heb': return 'Export English-Dictionary to Excel';
            case 'dictionary_heb_to_eng': return 'Export Hebrew-Dictionary to Excel';
            default: return 'Dictionary';
        }
    };

    return (
        <Stack direction="column" spacing={2} className="export-to-excel">
            {/* <Typography variant="h6" component="div" gutterBottom>
                {getDictionaryName(dictionary.current.dictionaryType)}
            </Typography> */}
            <Button
                variant="outlined"
                color="primary"
                size="large"
                fullWidth
                onClick={exportToExcel}
                startIcon={<DownloadIcon />}
            >
                ייצוא
            </Button>
        </Stack>
    );
});

export default ExportToExcel;
